import React from "react";
import Chart from "react-apexcharts";

class App extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        series: [{
          name: 'box',
          type: 'boxPlot',
          data: [
            {
              x: 'Team A',
              y: [45, 52, 76, 85, 101]
            },
            {
              x: 'Team B',
              y: [45, 52, 76, 85, 101]
            }
          ]
        }],
        options: {
          chart: {
            type: 'boxPlot',
            height: 350
          },
          title: {
            text: 'BoxPlot Example',
            align: 'left'
          },
          xaxis: {
            categories: ['Team A', 'Team B'],
          },
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: '50%'
            },
            boxPlot: {
              colors: {
                upper: '#e9ecef',
                lower: '#f8f9fa'
              }
            }
          },
          stroke: {
            colors: ['#6c757d']
          }
        },
      };
    }
  
    render() {
      return (
        <div className="app">
          <div className="row">
            <div className="mixed-chart">
              <Chart
                options={this.state.options}
                series={this.state.series}
                type="boxPlot"
                width="500"
              />
            </div>
          </div>
        </div>
      );
    }
  }
  
  export default App;